"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function fieldType(opts) {
    const { name, validate, clean, ...otherFields } = opts;
    const overwrittenValidate = (value, info = {}) => {
        if (!info.currentSchema) {
            info.currentSchema = {};
        }
        return validate(value, info);
    };
    const overwrittenClean = (value, info = {}) => {
        if (!info.options) {
            info.options = {};
        }
        if (clean) {
            return clean(value, info);
        }
        return value;
    };
    return {
        ...otherFields,
        name,
        validate: overwrittenValidate,
        clean: overwrittenClean,
        _isFieldType: true
    };
}
exports.default = fieldType;
